import { render, staticRenderFns } from "./MyRoutineTasks.vue?vue&type=template&id=10929f1e"
import script from "./MyRoutineTasks.vue?vue&type=script&lang=js"
export * from "./MyRoutineTasks.vue?vue&type=script&lang=js"
import style0 from "./MyRoutineTasks.vue?vue&type=style&index=0&id=10929f1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports